import React, { useState, useEffect, useRef } from 'react';
import Header2 from '../../Header2/Header2';
import Footer from '../Footer/Footer';
import '../../../css/presale.css';
import Bg from '../../../images/shapes/memecoin_bg_shape_1.svg';
import PepecoinSVG from '../../../images/pepecoin.svg';
import WalletConnectSVG from '../../../images/walletconnet.svg';
import Web3Modal from 'web3modal';
import { ethers } from 'ethers';
import WalletConnectProvider from '@walletconnect/web3-provider';

const PresalePage = () => {
  // State for the slider
  const [progress, setProgress] = useState(60);
  const [isDragging, setIsDragging] = useState(false);
  const [amountRaised, setAmountRaised] = useState(0);
  const [walletAddress, setWalletAddress] = useState("");
  const [showWalletOptions, setShowWalletOptions] = useState(false);
  
  // References for the slider
  const progressBarRef = useRef(null);
  const sliderHandleRef = useRef(null);
  const web3ModalRef = useRef();
  
  // Available wallet options
  const walletOptions = [
    { id: 'metamask', name: 'MetaMask' },
    { id: 'walletconnect', name: 'WalletConnect' },
    { id: 'coinbase', name: 'Coinbase Wallet' },
    { id: 'trustwallet', name: 'Trust Wallet' }
  ];
  
  // Calculate raised amount based on progress
  useEffect(() => {
    const targetAmount = 150000;
    const newAmount = (progress / 100) * targetAmount;
    setAmountRaised(newAmount);
  }, [progress]);
  
  // Initialize Web3Modal only once
  useEffect(() => {
    web3ModalRef.current = new Web3Modal({
      cacheProvider: false,
      providerOptions: {
        walletconnect: {
          package: WalletConnectProvider,
          options: {
            infuraId: "1c209b6e0e2e4e1e8e6e8e6e8e6e8e6e" // Replace with your Infura ID
          }
        }
      },
      theme: "dark",
      disableInjectedProvider: false,
      display: {
        logo: PepecoinSVG,
        name: "Connect Wallet",
        description: "Connect your wallet to continue"
      }
    });
  }, []);
  
  const connectWallet = async (walletType) => {
    try {
      setShowWalletOptions(false);
      const providerOptions = {
        walletconnect: {
          package: WalletConnectProvider,
          options: {
            infuraId: "1c209b6e0e2e4e1e8e6e8e6e8e6e8e6e"
          }
        }
      };

      web3ModalRef.current = new Web3Modal({
        cacheProvider: false,
        providerOptions,
        disableInjectedProvider: false
      });

      const externalProvider = await web3ModalRef.current.connect();
      const provider = new ethers.providers.Web3Provider(externalProvider);
      const signer = provider.getSigner();
      const address = await signer.getAddress();
      setWalletAddress(address);
    } catch (err) {
      console.error("Wallet connection failed", err);
    }
  };
  
  
  // Handle mouse down on slider handle
  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  
  // Handle mouse move while dragging
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    updateProgressFromEvent(e);
  };
  
  // Handle mouse up to end dragging
  const handleMouseUp = () => {
    setIsDragging(false);
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };
  
  // Handle touch events for mobile
  const handleTouchStart = (e) => {
    setIsDragging(true);
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', handleTouchEnd);
  };
  
  const handleTouchMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    updateProgressFromEvent(e.touches[0]);
  };
  
  const handleTouchEnd = () => {
    setIsDragging(false);
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('touchend', handleTouchEnd);
  };
  
  // Update progress based on mouse/touch position
  const updateProgressFromEvent = (e) => {
    if (progressBarRef.current) {
      const rect = progressBarRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const width = rect.width;
      const newProgress = Math.min(Math.max((x / width) * 100, 0), 100);
      setProgress(newProgress);
    }
  };
  
  // Handle click on progress bar
  const handleProgressBarClick = (e) => {
    updateProgressFromEvent(e);
  };

  return (
    <div className="index_memecoin page_wrapper" style={{ backgroundImage: `url(${Bg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', minHeight: '100vh' }}>
      <Header2 />
      <main className="page_content">
        <section className="presale_section section_space section_decoration">
          <div className="container">
            <div className="presale_card">
              <h2 className="presale_title">PRESALE IS LIVE</h2>
              
              <div className="presale_raised">${amountRaised.toLocaleString(undefined, {maximumFractionDigits: 2})} <span>RAISED</span></div>
              
              {/* Dynamic Slider */}
              <div className="presale_progress_wrap">
                <div 
                  className="presale_progress" 
                  ref={progressBarRef}
                  onClick={handleProgressBarClick}
                >
                  <div className="presale_progress-bar" style={{width: `${progress}%`}}></div>
                  <div 
                    className="presale_slider_handle green-handle"
                    ref={sliderHandleRef}
                    style={{left: `${progress}%`}}
                    onMouseDown={handleMouseDown}
                    onTouchStart={handleTouchStart}
                  >
                    <img src={PepecoinSVG} alt="Pepecoin" className="pepecoin-svg" />
                  </div>
                </div>
              </div>
              
              <div className="presale_info_row">
                <div>
                  <div className="presale_info_label">Current Price</div>
                  <div className="presale_info_value green-text">$0.0000335</div>
                </div>
                <div>
                  <div className="presale_info_label">Stage</div>
                  <div className="presale_info_value">2</div>
                </div>
                <div>
                  <div className="presale_info_label">Price at Launch</div>
                  <div className="presale_info_value green-text">$0.002</div>
                </div>
              </div>
              
              <div className="presale_payment_methods">
                <button className="presale_pay_btn active">ETH</button>
                <button className="presale_pay_btn">
                  USDT
                  <span className="erc20-label">ERC20</span>
                </button>
                <button className="presale_pay_btn">BNB</button>
                <button className="presale_pay_btn green-btn">Cryptos</button>
              </div>
              
              <div className="presale_input_row">
                <div className="presale_input_group">
                  <label>You Pay</label>
                  <input type="number" placeholder="Enter Amount" />
                  <span className="presale_input_currency green-text">ETH</span>
                </div>
                <div className="presale_input_group">
                  <label>You Receive</label>
                  <input type="text" value="0" readOnly />
                  <span className="presale_input_currency green-text">$DDGN</span>
                </div>
              </div>
              
              <div className="presale_btn_row">
                <button className="presale_bonus_btn">ADD BONUS CODE</button>
                <button className="presale_referral_btn">REFERRAL PROGRAM</button>
              </div>
              
              <div style={{ position: 'relative' }}>
                <button
                  className="presale_connect_btn green-connect-btn"
                  onClick={() => setShowWalletOptions(!showWalletOptions)}
                >
                  <div className="wallet-connect-wrapper">
                    <img src={WalletConnectSVG} alt="Wallet Connect" className="wallet-connect-svg" />
                    <span>{walletAddress ? `${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}` : "CONNECT WALLET"}</span>
                  </div>
                </button>
                
                {showWalletOptions && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: '#1a1a1a',
                    borderRadius: '8px',
                    padding: '10px',
                    marginTop: '5px',
                    zIndex: 1000,
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                  }}>
                    {walletOptions.map((wallet) => (
                      <button
                        key={wallet.id}
                        onClick={() => connectWallet(wallet.id)}
                        style={{
                          width: '100%',
                          padding: '10px',
                          margin: '5px 0',
                          backgroundColor: '#2a2a2a',
                          border: 'none',
                          borderRadius: '4px',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#3a3a3a'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#2a2a2a'}
                      >
                        {wallet.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PresalePage;